/*
  The initial state of the application.
  If we can chat to multiple people at once, we may need to change this.
  Here are the possible jabber ids (jids):
    person
    person@rootstechchat.org
    person@rootstechchat.org/location (such as from their phone or desktop)
*/
const ChatInitialState = {
  isLoading: true,
  failedToConnect: false,
  failedToConnectStatus: null,
  rosterNeedsReload: false,
  bookmarksNeedReload: false,
  connection: null,
  user: {
    authcid: null,
    authzid: null,
    jid: null,
  },
  onlinePeople: [],
  roster: [], // Managed outside of ChatReducer
  bookmarks: [], // Managed outside of ChatReducer
  unreadMessages: [
    // list by jids
  ],
  evaluatePeopleAddToRoster: [], // add person to roster if needed
  chatRoomsJoined: [],
}

const ChatReducer = (state, action) => {
  const change = { ...state }
  switch (action.type) {
    case 'CHAT_LOGIN':
      change.connection = action.connection
      change.user = action.user
      change.isLoading = false
      change.failedToConnect = false
      change.failedToConnectStatus = null
      break
    case 'PERSON_PRESENCE':
      if (action.data.isOnline) {
        change.onlinePeople = [...change.onlinePeople, action.data.jid]
      } else {
        change.onlinePeople = change.onlinePeople.filter((p) => p !== action.data.jid)
      }
      break
    case 'LOAD_UNREAD_MESSAGES_FROM_CACHE':
      change.unreadMessages = action.data
      break
    case 'UNREAD_MESSAGE':
      if (!change.unreadMessages.includes(action.fromJid?.toLowerCase())) {
        change.unreadMessages = [...change.unreadMessages, action.fromJid.toLowerCase()]
      }
      break
    case 'CLEAR_UNREAD_MESSAGE':
      if (change.unreadMessages.includes(action.jid?.toLowerCase())) {
        change.unreadMessages = change.unreadMessages.filter((i) => i.toLowerCase() !== action.jid.toLowerCase())
      }
      break
    case 'FAILED_TO_CONNECT':
      change.failedToConnect = true
      change.failedToConnectStatus = action.data
      break
    case 'EVALUATE_ADD_PERSON':
      if (!change.evaluatePeopleAddToRoster.includes(action.fromJid)) {
        change.evaluatePeopleAddToRoster = [...change.evaluatePeopleAddToRoster, action.fromJid.toLowerCase()]
      }
      break
    case 'EVALUATE_ADD_PERSON_COMPLETE':
      if (change.evaluatePeopleAddToRoster.includes(action.jid)) {
        change.evaluatePeopleAddToRoster = change.evaluatePeopleAddToRoster.filter((i) => i !== action.jid)
      }
      break
    case 'ROOMS_AUTO_JOIN_SUCCESS':
      if (!change.chatRoomsJoined.includes(action.from)) {
        change.chatRoomsJoined = [...change.chatRoomsJoined, action.from.toLowerCase()]
      }
      break
    case 'IS_NOT_LOGGED_IN':
      return { ...ChatInitialState, isLoading: false, ChatReducer }
    case 'LOGOUT':
      return { ...ChatInitialState, ChatReducer }
    default: {
      console.error(`ERROR: Unhandled action type: ${action.type}`) // eslint-disable-line
    }
  }

  return { ...change }
}

export { ChatInitialState, ChatReducer }
